import StatusBadge from '@/components/common/StatusBadge';
import GlassCard from '@/components/GlassCard';
import React from 'react';

interface EvaluationAttemptSummary {
    id: number;
    evaluation_id: number;
    evaluation_title: string;
    score: number;
    total_score: number;
    percentage: number;
    passed: boolean | null;
    completed_at: string | null;
    has_answers: boolean;
}

interface EvaluacionesProps {
    evaluaciones: EvaluationAttemptSummary[];
}

function formatDate(iso: string | null): string {
    if (!iso) {
        return '—';
    }
    return new Date(iso).toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    });
}

const Evaluaciones: React.FC<EvaluacionesProps> = ({ evaluaciones }) => {
    if (evaluaciones.length === 0) {
        return (
            <GlassCard className="p-8 text-center">
                <p className="text-gray-500 dark:text-neutral-400">
                    No tienes evaluaciones completadas todavía.
                </p>
            </GlassCard>
        );
    }

    return (
        <div className="space-y-3">
            {evaluaciones.map((attempt) => (
                <GlassCard
                    key={attempt.id}
                    as="link"
                    href={`/my-account/evaluations/${attempt.id}/`}
                    className="flex items-center justify-between gap-4 px-5 py-4"
                >
                    <div className="min-w-0 flex-1">
                        <p className="truncate font-medium text-gray-900 dark:text-white">
                            {attempt.evaluation_title}
                        </p>
                        <p className="mt-0.5 text-sm text-gray-500 dark:text-neutral-400">
                            {formatDate(attempt.completed_at)}
                        </p>
                    </div>
                    <div className="flex shrink-0 items-center gap-4">
                        <div className="text-right">
                            <p className="text-sm font-semibold text-gray-900 dark:text-white">
                                {attempt.score} / {attempt.total_score}
                            </p>
                            <p className="text-xs text-gray-500 dark:text-neutral-400">
                                {attempt.percentage}%
                            </p>
                        </div>
                        <StatusBadge
                            status={
                                attempt.passed === true
                                    ? 'approved'
                                    : attempt.passed === false
                                      ? 'rejected'
                                      : undefined
                            }
                            label={
                                attempt.passed === null
                                    ? 'Pendiente'
                                    : undefined
                            }
                            color={attempt.passed === null ? 'gray' : undefined}
                        />
                    </div>
                </GlassCard>
            ))}
        </div>
    );
};

export default Evaluaciones;
